import { useQuery } from '@tanstack/react-query';
import { Appointment } from 'src/models';
import { api } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

type ClinicalNote = {
  appointment_id: number;
  author: string | null;
  content: string;
  content_type: 'text';
  created_at: string | null;
  created_by: string | null;
  date: string;
  ehr_system: string;
  identifier: string;
  is_deleted: boolean;
  last_modified_by: string | null;
  last_updated: string | null;
  meta: {
    encounter_id: string;
  };
  note_id: string;
  org_uuid: string;
  patient_id: number;
  s3_url: string;
  section: unknown | null;
  status: 'summary_generated';
  type: unknown | null;
  version: unknown | null;
};

export type GetEhrAppointmentsResponse = {
  appointments: Appointment[];
  clinical_notes: ClinicalNote[];
};

export type UseGetEhrAppointmentsParams = {
  patientId: number;
  count: number;
  practitionerId: number;
  appointmentId: number;
};

export const useGetEhrAppointments = (
  payload: UseGetEhrAppointmentsParams,
  options: UseQueryOverrideOptions = {}
) => {
  const { patientId, count, practitionerId, appointmentId } = payload;

  return useQuery({
    queryKey: ['ehrAppointments', payload],
    queryFn: () =>
      api
        .get<GetEhrAppointmentsResponse>('/ehr/appointments', {
          params: {
            patient_id: patientId,
            count,
            practitioner_id: practitionerId,
            appointment_id: appointmentId,
          },
        })
        .then((res) => res.data),
    refetchOnWindowFocus: false,
    ...options,
  });
};
